export default __webpack_public_path__ + "static/media/element_spec_19.4caea540.webp";